export default "__VITE_ASSET__BJTx0i8o__"